import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/gws/SearchBar";
import Table from "../components/gws/Table";
import { USER_TYPE, PERMISSIONS } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const Gws = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.GW);
  // 事業者種別取得
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);

  return (
    <SpaceBetween size="l">
      {isDocomoUser && <SearchBar />}
      <Table />
    </SpaceBetween>
  );
};

export default Gws;
